import React, { useEffect, FC } from "react";
import { createPortal } from "react-dom";

interface Props {
  children: React.ReactNode;
}

const Portal: FC<Props> = (props: Props) => {
  const { children } = props;

  const mount = document.getElementById("modal-portal");
  const div = document.createElement("div");

  useEffect(() => {
    mount.appendChild(div);
    return () => {
      mount.removeChild(div);
    };
  }, [div, mount]);

  return createPortal(children, mount);
};

export default Portal;
